import { render, staticRenderFns } from "./StatistikenPage.vue?vue&type=template&id=510396d6&scoped=true&"
import script from "./StatistikenPage.vue?vue&type=script&lang=ts&"
export * from "./StatistikenPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510396d6",
  null
  
)

export default component.exports